import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/App'
import router from './router'
import store from './store'

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

sync(store, router)

const app = new Vue({
  router,
  store,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js